"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.9997 3.33301C16.7033 3.33301 13.481 4.31049 10.7402 6.14185C7.99936 7.9732 5.86315 10.5762 4.60169 13.6216C3.34023 16.667 3.01017 20.0182 3.65326 23.2512C4.29635 26.4842 5.88369 29.4539 8.21457 31.7848C10.5454 34.1157 13.5152 35.703 16.7482 36.3461C19.9812 36.9892 23.3323 36.6591 26.3777 35.3977C29.4232 34.1362 32.0261 32 33.8575 29.2592C35.6889 26.5184 36.6663 23.296 36.6663 19.9997C36.6614 15.5809 34.9038 11.3446 31.7793 8.22007C28.6548 5.09554 24.4184 3.338 19.9997 3.33301ZM18.7176 12.3074C18.7176 11.9673 18.8527 11.6412 19.0931 11.4008C19.3336 11.1604 19.6597 11.0253 19.9997 11.0253C20.3397 11.0253 20.6658 11.1604 20.9062 11.4008C21.1467 11.6412 21.2817 11.9673 21.2817 12.3074V21.2817C21.2817 21.6217 21.1467 21.9478 20.9062 22.1883C20.6658 22.4287 20.3397 22.5638 19.9997 22.5638C19.6597 22.5638 19.3336 22.4287 19.0931 22.1883C18.8527 21.9478 18.7176 21.6217 18.7176 21.2817V12.3074ZM19.9997 28.974C19.6193 28.974 19.2475 28.8612 18.9313 28.6499C18.615 28.4386 18.3685 28.1383 18.223 27.7869C18.0774 27.4355 18.0394 27.0488 18.1136 26.6758C18.1878 26.3027 18.3709 25.9601 18.6399 25.6911C18.9088 25.4222 19.2515 25.239 19.6245 25.1648C19.9975 25.0906 20.3842 25.1287 20.7356 25.2743C21.087 25.4198 21.3873 25.6663 21.5987 25.9825C21.81 26.2988 21.9228 26.6706 21.9228 27.051C21.9228 27.561 21.7201 28.0501 21.3595 28.4108C20.9988 28.7714 20.5097 28.974 19.9997 28.974Z",
    fill: fill
  }));
};

exports["default"] = _default;